var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("workshop-management", {
    attrs: {
      "add-participant": _vm.apis.workshop.addWorkshopParticipant,
      "application-id": _vm.applications.Provider,
      "download-certificate": _vm.apis.workshop.downloadWorkshopCertificate,
      "download-file": _vm.apis.workshop.downloadDocumentByAttachmentId,
      "get-all": _vm.apis.workshop.getAllWorkshop,
      "get-details": _vm.apis.workshop.getWorkshopDetail,
      "get-statuses": _vm.apis.workshop.getWorkshopStatuses,
      "last-registered-participant": _vm.apis.workshop.getLatestParticipant,
      redeem: _vm.apis.workshop.redeemWorkshop,
      "update-participant-status":
        _vm.apis.workshop.updateParticipantWorkshopStatus,
      "validate-tests": _vm.apis.workshop.validateWorkshopTests
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }